import { renderCalcPos, onAnyStandardCell } from '../../helpers/helpers'
import { validateMarginRatio } from '../../helpers/validators'
import type { CalculationColumn } from '../../types/column-types'

export const calculatedMarginRatioColumn: CalculationColumn = {
    dataIndex: ['calculated', 'marginRatio'],
    title: 'Коеф. нац.',
    width: 46,
    validator: validateMarginRatio,
    onCell: onAnyStandardCell,
    render: renderCalcPos(r => Math.round((r.calculated?.marginRatio || 0) * 100) / 100),
}
